export const ADD_MAPPER = "ADD_MAPPER";
export const GET_MAPPERS = "GET_MAPPERS";
export const DELETE_MAPPER = "DELETE_MAPPER";
export const ERROR = "ERROR";
